import type {
  ActionRequestType,
  InteractionActionRequest,
} from './interaction-operational-contracts'

export const REQUEST_LABELS: Record<ActionRequestType, string> = {
  APPOINTMENT_REQUEST: 'Appointment request',
  CALLBACK_REQUEST: 'Callback request',
  CANCELLATION_REQUEST: 'Cancellation request',
  RESCHEDULE_REQUEST: 'Reschedule request',
}

export function statusTime(timestamp: number) {
  const date = new Date(timestamp)
  const sameDay = date.toDateString() === new Date().toDateString()
  return new Intl.DateTimeFormat(
    undefined,
    sameDay
      ? { hour: 'numeric', minute: '2-digit' }
      : { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }
  ).format(timestamp)
}

export function requestSummary(
  types: ActionRequestType[],
  count: number,
  mixed = 'open requests'
) {
  if (types.length === 1 && count === 1) return REQUEST_LABELS[types[0]!]
  if (types.length === 1) return `${count} × ${REQUEST_LABELS[types[0]!]}`
  return `${count} ${mixed}`
}

export function summarizeRequests(
  items: InteractionActionRequest[],
  mixed = 'requests'
) {
  return requestSummary(
    [...new Set(items.map((item) => item.requestType))],
    items.length,
    mixed
  )
}

export function requestSource(item: InteractionActionRequest) {
  return `${item.sourceChannel === 'VOICE' ? 'Voice' : 'SMS'} · ${statusTime(item.createdAtMs)}`
}

// The completions that settled the conversation: made after its latest activity.
export function completionsSince(
  items: InteractionActionRequest[],
  activityAtMs: number
) {
  return items.filter(
    (item) =>
      item.status === 'RESOLVED' &&
      item.resolution !== null &&
      item.resolution.resolvedAtMs >= activityAtMs
  )
}
